import { FC, MouseEvent } from 'react'
import { RocketLaunchIcon } from '@heroicons/react/24/outline'
import { CgSpinner } from 'react-icons/cg'

import { StoreWithDeployStatus } from '@/models/operations/types'
import { classNames } from '@/utils'

import {
  ClearCacheIcon,
  OPS_ROW_ACTION_ICON_CLASS,
  cardActionIconButtonClass,
} from './opsUiShared'

type OpsStoreActionButtonsProps = {
  store: StoreWithDeployStatus
  onRedeploy: (store: StoreWithDeployStatus) => void
  onClearCache: (store: StoreWithDeployStatus) => void
  isLoading?: boolean
  disabled?: boolean
}

const stopRowClick = (e: MouseEvent) => {
  e.stopPropagation()
}

const OpsStoreActionButtons: FC<OpsStoreActionButtonsProps> = ({
  store,
  onRedeploy,
  onClearCache,
  isLoading = false,
  disabled = false,
}) => {
  const isFailed = store.deployUiState === 'failed'
  const publishLabel = isFailed ? 'Retry publish' : 'Publish'

  return (
    <div className="flex items-center justify-center gap-2 h-full w-full">
      <button
        type="button"
        className={cardActionIconButtonClass('green')}
        disabled={disabled}
        onClick={(e) => {
          stopRowClick(e)
          onRedeploy(store)
        }}
        aria-label={publishLabel}
        title={publishLabel}
      >
        {isLoading ? (
          <CgSpinner className={classNames(OPS_ROW_ACTION_ICON_CLASS, 'animate-spin')} />
        ) : (
          <RocketLaunchIcon className={OPS_ROW_ACTION_ICON_CLASS} />
        )}
      </button>
      <button
        type="button"
        className={cardActionIconButtonClass('red')}
        disabled={disabled}
        onClick={(e) => {
          stopRowClick(e)
          onClearCache(store)
        }}
        aria-label="Purge cache"
        title="Purge cache"
      >
        <ClearCacheIcon className={OPS_ROW_ACTION_ICON_CLASS} />
      </button>
    </div>
  )
}

export { OpsStoreActionButtons }
